import historyTabTemplate from '@/audit/layout/historyTabTemplate';

export default historyTabTemplate(['collections'], ({ collections }) => collections.audit, 'collection');
